export function capitalize(word : string){
    return `${word.charAt(0).toUpperCase()}${word.slice(1)}`;
}

export function parseDate(date : string){
    const dateObject = new Date(date);

    const dayName = dateObject.toLocaleString("it-IT", {weekday : "long"});
    const dayNumber = dateObject.getDate();
    const monthName = dateObject.toLocaleString("it-IT", {month : "long"})
    const fullYear = dateObject.getFullYear();

    return `${capitalize(dayName)} ${dayNumber} ${capitalize(monthName)} ${fullYear}`;
}

export function getFormattedDate(date : Date) : string{
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;

}